import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'

import type { PromptTemplateDrawerFormSchemaType } from './prompt-template-drawer-form.schema'

const DESCRIPTION_MAX_LENGTH = 500

interface PromptTemplateDescriptionFieldProps {
  form: UseFormReturn<PromptTemplateDrawerFormSchemaType>
  isDisabled?: boolean
}

export const PromptTemplateDescriptionField = ({
  form,
  isDisabled = false,
}: PromptTemplateDescriptionFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="description"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Description</FormLabel>
        <FormControl>
          <Textarea
            placeholder="Briefly describe what this template is for"
            className="prompt-template-description-input resize-none"
            rows={2}
            maxLength={DESCRIPTION_MAX_LENGTH}
            disabled={isDisabled}
            {...field}
          />
        </FormControl>
        <FormDescription>
          A short summary to help identify this template in the list
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
)

PromptTemplateDescriptionField.displayName = 'PromptTemplateDescriptionField'
